module.exports = __webpack_public_path__ + "kw.svg?7fc3a356d2bc3b247db3f5c8db3d2eec";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/kw.svg
// module id = 856
// module chunks = 27